import { is } from '@gov-nx/core/types';
import type {
	Category,
	CategoryRowValue,
	CategoryWithItems,
} from '@gov-nx/module/service';

type CategoryRow = [string, CategoryRowValue];

export const shouldDisplayRow = ([itemRowKey]: CategoryRow) =>
	itemRowKey !== 'type' && itemRowKey !== 'id';

export const categoryRecordNotUndefined = (
	categoryRecord: [string, Category | undefined]
): categoryRecord is [string, Category] => is(categoryRecord[1]);

export const isCategorySelected = (
	isSelected: (key: string) => boolean,
	key: string
) => isSelected(key) || isSelected(`${key}:*`);

// Recap needs to include an indeterminate state as selected - that's why we use an extended version of this function
export const isCategorySelectedForRecap = (
	isSelected: (key: string) => boolean,
	key: string,
	category: Category
): boolean => {
	// Entire category is selected
	if (isCategorySelected(isSelected, key)) return true;

	// Check if at least one subcategory is selected
	if (category.type === 'list') {
		const categoryWithItems = category as CategoryWithItems;
		return categoryWithItems.items.some((item) =>
			isSelected(`${key}:${item.id}`)
		);
	}

	return false;
};

export const isSubcategorySelected = (
	isSelected: (key: string) => boolean,
	categoryKey: string,
	itemId: string
) => isSelected(`${categoryKey}:${itemId}`) || isSelected(`${categoryKey}:*`);

export const isVedlejsiDrzitelFOArray = (
	value: CategoryRowValue
): value is { [key: string]: string | undefined }[] =>
	Array.isArray(value) &&
	value.every(
		(item) => typeof item === 'object' && item !== null && !Array.isArray(item)
	);

// Distinguish between array and string value
export const getSingleLevelTableRowValue = (
	rowValue: CategoryRowValue,
	emptyValueString: string
) => {
	if (Array.isArray(rowValue)) {
		return rowValue.filter(is).length === 0
			? emptyValueString
			: rowValue.join(', ');
	}
	return `${is(rowValue) ? rowValue : emptyValueString}`;
};
